query approvalFlowAbilities($userId: ID!) {
  base {
    user(id: $userId) {
      id
      abilities {
        can_participate_in_approval_flow
        can_submit_proposals
        can_pre_approve_proposals
        can_incorporate_proposals
        __typename
      }
      __typename
    }
    __typename
  }
}
